// src/onboarding.tsx
import SvgIcon from "@mui/material/SvgIcon";
import { jsx } from "react/jsx-runtime";
var OnboardingIcon = (props) => /* @__PURE__ */ jsx(SvgIcon, { viewBox: "0 0 24 24", ...props, children: /* @__PURE__ */ jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5 19h-19v2h19v-2ZM20.23 8.58c.8-.22 1.63.26 1.84 1.06.21.8-.26 1.62-1.07 1.85-9.45 2.53-16.57 4.43-16.57 4.43l-2.59-4.49 1.45-.39 1.97 1.54 4.97-1.33-4.14-7.17 1.93-.51 6.9 6.43 5.31-1.42Zm-8.374.564a.144.144 0 0 1 .288 0c0 .393.32.712.712.712a.144.144 0 0 1 0 .288.712.712 0 0 0-.712.712.144.144 0 0 1-.288 0 .712.712 0 0 0-.712-.712.144.144 0 0 1 0-.288c.393 0 .712-.32.712-.712Z",
    fill: "currentColor"
  }
) });

export {
  OnboardingIcon
};
